module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_vm._v("BROTHERS")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("When Jordan returned to the wardroom, most of the men and women were still there, sitting around the tables, deep in conversations.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Who wants to be next?” Jordan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They all looked up at him, standing just inside the hatch.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Geoffrey Hazzard, back from the command center, got to his feet. “Might’s well get it over with.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As he brushed past Jordan and stepped out into the passageway, most of the others got to their feet, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I suppose we should get to our quarters and settle in a bit,” said Harmon Meek.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I know it’s a bit daft,” said Thornberry as he headed for the hatch, “but I feel like I need a nap.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Meek looked down his nose at the beefy engineer. “That’s ridiculous. You’ve been sleeping for eighty years, man.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes. A bit of strange, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon started to leave too, but Jordan touched his sleeve to hold him back. “Wait a moment, Bran, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With a glance at Elyse, who looked back over her shoulder at him, Brandon leaned his rump on the edge of the nearest table. Jordan waited until Elyse and the others left the wardroom, then turned to his younger brother.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Bran, do you really feel so … so … alienated?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Alienated?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What you said earlier, about us being outcasts, expendables.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon didn’t reply. Jordan looked into his brother’s light bluish gray eyes and thought, It’s almost like looking into a mirror. A very flattering mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well?” he prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon turned away slightly, but he answered, “It’s true, isn’t it? None of us are the best and brightest of their professions, are we? I’m certainly not. There are a dozen planetary astronomers who are better than I: better reputations, recognized leaders in the field. I’m just an also-ran.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But the IAA picked "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("you")]), _vm._v(" for this mission! Of all the people in the field they picked you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Because I’m expendable,” Brandon repeated stubbornly. “Because nobody’s going to miss me for a century or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Shaking his head, Jordan countered, “But the honor of taking part in the first human mission to another star! Surely—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Bullshit,” Brandon snapped. “They picked us because we’re expendable. Look at us, Jordan. Aside from you, none of us are leaders in our fields. We’re all expendables. No family ties. Nobody’s going to miss us, whether we come back or not. That’s why they picked us. That’s why we’ve been given this "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("honor")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Before Jordan could reply, Brandon added, “And now they’ve hung us out to dry. No backup mission. The damned politicians got their glory by sending us out here, they don’t give a damn if we get back or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You really feel that way?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes. Don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Miriam’s death flashed in Jordan’s memory once more. I killed her, he thought all over again. If I hadn’t insisted on that doomed mission to Kashmir she’d still be alive.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No,” he lied. “I really do feel it’s an honor to be picked for this mission. Especially for a non-scientist, a mere administrator.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For the first time, Brandon smiled. “Mere administrator,” he said. “One of the world’s most distinguished diplomats. And now head of this mission. They should have given you a whip and a chair. You’re going to need them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan smiled. “Riding herd on eleven scientists and engineers shouldn’t be that difficult, really.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You don’t think so?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I hope not.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Gazing straight into Jordan’s eyes, Brandon asked, “Tell me the truth now, why did you agree to come on this mission?” Before Jordan could think of a reply, Brandon added, “And don’t tell me about the honor. You’ve already had honors enough for any man.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It will look very impressive on my résumé.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your résumé’s already damned impressive,” Brandon said. “Come on now, the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("To get away from the memories, Jordan knew. To get as far away from the Kashmir and Miriam’s death as humanly possible.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well?” Brandon persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan shrugged. “The truth? Why, I came along to be with my baby brother. Somebody’s got to keep you out of trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The sour expression on Brandon’s face told Jordan what his brother thought of that excuse.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re a diplomat,” Brandon said, “a troubleshooter, an administrator—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You mean a bureaucrat,” said Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What you accomplished in South America wasn’t bureaucracy. You stopped a bloody war.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan dipped his chin in acknowledgment.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And China,” Brandon went on. “And the Sahel drought.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Don’t mention Kashmir, Jordan begged silently. Not India and the Kashmir.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I just don’t see what made you agree to come on this operation.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Forcing a smile, he said to his brother, “Adventure. Romance and adventure.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Bull.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And family ties,” Jordan added.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“More bull.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Getting away from the memories, Jordan added silently. Getting as far away from anything connected with Miriam as I can. Away from the emptiness and the remorse. Away from the guilt. He ran a hand through his hair, wondering what he could tell his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He decided to change the subject, instead. Jordan pointed to the wall screen. “Look, there’s the terminator coming up. We’re moving into the night side.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Darkness swallowed the view. In a moment, though, false-color infrared imagery filled the screen. Still, there was nothing much to see, only endless forests.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But then a pinpoint glow of light appeared in the midst of the darkness.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec4c8466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter8.vue
// module id = 99
// module chunks = 0